import React from 'react';
import { motion } from 'framer-motion';

export default function LocationMap() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="bg-gray-50 rounded-xl shadow-md overflow-hidden"
    >
      <div className="p-8 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Location</h2>
        <p className="text-lg text-gray-700 mb-6">
          Visit us at our office in Kampala, Uganda.
        </p>
      </div>
      <div className="relative h-[450px] w-full">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15953.200353424373!2d32.616389!3d0.328333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbbe6fabc442f%3A0x897fb573bcbbeba6!2sMakerere%20University%20Business%20School!5e0!3m2!1sen!2sug!4v1690000000000" 
          className="absolute inset-0 w-full h-full border-0"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </motion.div>
  );
}
